const API_URL = process.env.REACT_APP_API_URL || 'https://geroiyar.yarcloud.ru';

export const NewsService = {
  
  async fetchNews() {
    try {
      const response = await fetch(API_URL+'/api/news-items/?populate=titleImage');
      if (!response.ok) throw new Error('Ошибка загрузки новостей');
      const { data } = await response.json();
 
      return data.map((item) => ({
        id: String(item.documentId),
        title: item.title,
        description: item.description,
        date: item.date || item.publishedAt,
        img: item.titleImage?.url 
          ? API_URL+`${item.titleImage.url}`
          : null,
        body: item.body
      }));
    } catch (error) {
      throw new Error('Не удалось загрузить новости: ' + error.message);
    }
  },

  async fetchNewsItem(id) {
    try {
      const response = await fetch(API_URL+`/api/news-items/${id}?populate=titleImage`);
      if (!response.ok) throw new Error('Новость не найдена');
      const { data } = await response.json();
      
      return {
        id: String(data.documentId),
        ...data,
        img: data.titleImage?.url 
          ? `${API_URL}${data.titleImage.url}`
          : null,
        largeImg: data.titleImage?.formats?.large?.url
          ? API_URL+`${data.titleImage?.formats?.large?.url}`
          : null,
      };
    } catch (error) {
      throw new Error('Не удалось загрузить новость: ' + error.message);
    }
  }
};